// src/store/useNewsStore.ts
import { create } from "zustand";
import { EventsItem } from "../types/events";
import { getEventsApi, getEventsDetailApi } from "../api/eventsApi";

interface EventsState {
  items: EventsItem[];
  detail: EventsItem | null;
  currentPage: number;
  totalPages: number;
  loading: boolean;
  error: string | null;

  fetchEvents: (lang: "id" | "en", page?: number) => Promise<void>;
  fetchEventsDetail: (lang: "id" | "en", slug: string) => Promise<void>;
}

export const useEventsStore = create<EventsState>((set) => ({
  items: [],
  detail: null,
  currentPage: 1,
  totalPages: 1,
  loading: false,
  error: null,

  // =======================
  // LIST NEWS
  // =======================
  fetchEvents: async (lang, page = 1) => {
    try {
      set({ loading: true, error: null });

      const res = await getEventsApi(lang, page);

      // ✅ SESUAI RESPONSE API
      const events = res.events;

      const mapped: EventsItem[] = events.data.map((item: any) => ({
        id: item.id ?? item.slug,
        title: item.title,
        slug: item.slug,
        image: item.image,
        event_image_icon: item.event_image_icon,
        category: item.category_name,
        contentHtml: item.content,
        date: item.published_at
          ? new Date(item.published_at).toLocaleDateString(
              lang === "id" ? "id-ID" : "en-US",
              { year: "numeric", month: "long", day: "numeric" }
            )
          : "",
        tags: item.tag?.map((t: any) => t.name) || [],
      }));

      set({
        items: mapped,
        currentPage: events.current_page,
        totalPages: events.last_page,
      });
    } catch (err) {
      console.error("fetchNews error:", err);
      set({ error: "Failed to fetch news" });
    } finally {
      set({ loading: false });
    }
  },

  // =======================
  // DETAIL NEWS
  // =======================
  fetchEventsDetail: async (lang, slug) => {
    try {
      set({ loading: true, error: null, detail: null });

      const res = await getEventsDetailApi(lang, slug);

      // ⬇️ SESUAIKAN DENGAN RESPONSE API
      const item = res.event ?? res.data;

      const mapped: EventsItem = {
        id: item.id ?? item.slug,
        title: item.title,
        slug: item.slug,
        image: item.image,
        event_image_icon: item.event_image_icon,
        category: item.category_name,
        contentHtml: item.content,
        date: item.published_at
          ? new Date(item.published_at).toLocaleDateString(
              lang === "id" ? "id-ID" : "en-US",
              { year: "numeric", month: "long", day: "numeric" }
            )
          : "",
        tags: item.tag?.map((t: any) => t.name) || [],
      };

      set({ detail: mapped });
    } catch (err) {
      console.error("fetchNewsDetail error:", err);
      set({ error: "Failed to fetch news detail" });
    } finally {
      set({ loading: false });
    }
  },
}));
